import React from 'react'

import './homepage.css';

import Text from '../assets/homepage/GlowText.png';
import Text2 from '../assets/homepage/GlowText2.png';
import Phone from '../assets/homepage/Phone.png';
import Phone2 from '../assets/homepage/Phone2.png';

import PlayStore from '../assets/rewardDesc/playstore.png';
import PlayStore2 from '../assets/homepage/play-store.png';

import Tilt from 'react-parallax-tilt';

import bg from '../assets/homepage/bg.png';
import ph from '../assets/homepage/ph.png';



const homepage = () => {
    return (
        <>
            <div className="hero-page">
                <div className="left-hero">
                    <div className="left-hero-section">
                        <img src={Text2} alt="" id="text" />
                        <p><span>RewardPro</span> is an Android app that lets you earn coin for playing Games, watching videos & referring your friends. You can then Redeem the coins & transfer them directly to your Paytm Wallet.
                        </p>
                        <div className="play">
                            <img src={PlayStore2} alt="" className="btn-zoom" />
                        </div>
                    </div>
                </div>
                <div className="right-hero">
                    <img src={bg} alt="" />
                    <Tilt>
                        <img src={ph} alt="" />
                    </Tilt>
                </div>
                {/* <Tilt>
                    <div className="right-hero">
                        <img src={Phone2} alt="" />
                    </div>
                </Tilt> */}
            </div>
        </>
    )
}

export default homepage
